// extracted by mini-css-extract-plugin
export default {"autocompleteBackground":"Style_autocompleteBackground__uhUPR"};